module.exports = __webpack_public_path__ + "assets/img/images_i.73c9ffb1.png";